
import React, { Component } from 'react';
import isArray from 'lodash/isArray';

import OpenLayersMap from './openlayers/OpenLayersMap';
import MapCommander from './openlayers/MapCommander';

class MapBase extends Component {

    createMap(map, layers) {
        this._olMap = new OpenLayersMap({
            interactions: this.props.olInteractions,
            onChangeView: this.handleChangeView,
            onFeatureClick: this.handleFeatureClick,
            onMapClick: this.handleMapClick,
            onMapToolExecute: this.handleMapToolExecute
        });

        this._olMap.createMap(
            this.refs.mapContainer,
            map.definition,
            this.getViewState(map, layers)
        );

        this._mapCommander = new MapCommander({
            olMap: this._olMap,
            onCommandExecuted: this.handleMapCommanderOnCommandExecuted
        });
    }

    componentDidMount() {
        if (this.props.map.definition) {
            this.createMap(this.props.map, this.props.layers);

            // ToDo: is this correct for initialize parent state?
            this.handleChangeView(
                this._olMap.getView().getCenter(),
                this._olMap.getView().getZoom(),
                this._olMap.getView().getRotation(),
                this._olMap.getView().getResolution()
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.map.definition !== this.props.map.definition)) {
            this.createMap(this.props.map, this.props.layers);
        }
        if (prevProps.layers !== this.props.layers) {
            this.changeLayerVisibility(this.props.layers);
        }
        if (prevProps.map.commands.list !== this.props.map.commands.list) {
            if (this.props.map.commands.list.length > 0) {
                this.execCommand(this.props.map.commands.list[0]);
            }
        }
    }

    changeLayerVisibility(virtualLayers) {
        if (this._olMap) {
            this._olMap.changeLayerVisibility(virtualLayers);
        }
    }

    execCommand(command) {
        this._mapCommander.execute(command);
    }

    getMapCenter(mapState) {
        let center = mapState.center || mapState.definition.center;
        if (!center && mapState.definition.extent) {
            let extent = mapState.definition.extent;
            if (isArray(extent) && (extent.length === 4)) {
                center = [
                    (extent[0] + extent[2]) / 2,
                    (extent[1] + extent[3]) / 2
                ];
            }
        }
        if (this.props.queryParams && this.props.queryParams.coord) {
            try {
                const coords = this.props.queryParams.coord.split(',');
                center = [
                    parseInt(coords[0], 10),
                    parseInt(coords[1], 10)
                ];
            } catch (e) {
                // nop;
            }
        }
        return center;
    }

    getMapDefaultExtension(mapState) {
        return (this.props.defaultExtent)
            ? this.props.defaultExtent
            : mapState.definition.extent;
    }

    getMapZoom(mapState) {
        let zoom = mapState.zoom || mapState.definition.zoom;
        if (this.props.queryParams && this.props.queryParams.zoom) {
            try {
                zoom = parseInt(this.props.queryParams.zoom, 10);
            } catch (e) {
                // nop;
            }
        }
        return zoom;
    }

    getLayers(layers) {
        return [
            ...layers
        ];
    }

    getOlMap() {
        return this._olMap;
    }

    getViewState(map, layers) {
        let viewState = {
            center: this.getMapCenter(map),
            defaultExtent: this.getMapDefaultExtension(map),
            rotation: map.rotation,
            zoom: this.getMapZoom(map),
            layers: this.getLayers(layers)
        };
        return viewState;
    }

    getVisibleLayers() {
        return this.props.layers.filter(item => {
            return (item.visible);
        }).map(item => {
            return item.id;
        });
    }

    handleChangeView = (center, zoom, rotation, resolution) => {
        if (this.props.onChangeView) {
            this.props.onChangeView(center, zoom, rotation, resolution);
        }
    }

    handleFeatureClick = (feature) => {
        if (this.props.onFeatureClick) {
            this.props.onFeatureClick(feature);
        }
    }


    handleMapClick = (coord) => {
        if (this.props.onMapClick) {
            this.props.onMapClick(coord);
        }
    }

    handleMapToolExecute = (toolId, params) => {
        if (this.props.onMapToolExecute) {
            this.props.onMapToolExecute(toolId, params);
        }
    }

    handleMapCommanderOnCommandExecuted = (id) => {
        if (this.props.moduleActions) {
            this.props.moduleActions.removeCommand(id);
        }
    }

    render() {
        return (
            <div ref="mapContainer" style={{display: 'flex', flex: '1 0'}}></div>
        );
    }

    updateSize() {
        if (this._olMap && this.refs.mapContainer) {
            let size = [
                this.refs.mapContainer.clientWidth,
                this.refs.mapContainer.clientHeight
            ];
            this._olMap.getMap().setSize(size);
        }
    }
};

export default MapBase;
